import { post, userApiRoute } from './Api';
import { getBrowserTimezone } from './DateTime.js';
import { useNavigate } from 'react-router-dom';
import { getCookie, isMobile } from '~/lib/Utils';

export function getCreateBusinessParams() {
    return {
        timezone: getBrowserTimezone(),
        source: localStorage.getItem('referral-source') || '', // This is set in referral.blade.php
        marketing: localStorage.getItem('marketing-source') || '', // This is set in marketing-tracking.blade.php
        anonymousId: localStorage.getItem('anonymousId') || '',
        ampDeviceId: localStorage.getItem('ampDeviceId') || '',
        ampSessionId: localStorage.getItem('ampSessionId') || '',
        mobile: isMobile(),
        fbp: getCookie('_fbp') || '',
        fbc: getCookie('_fbc') || '',
        ...getGoogleClick(),
    };
}

/**
 * Google Ads click id (gclid/gbraid/wbraid) set in marketing-tracking.blade.php, used to
 * upload conversions for the business server side
 */
function getGoogleClick() {
    try {
        const click = JSON.parse(localStorage.getItem('google-click') || 'null');
        if (!click) {
            return {};
        }

        return {
            gclid: click.gclid || '',
            gbraid: click.gbraid || '',
            wbraid: click.wbraid || '',
            googleClickAt: click.capturedAt || '',
        };
    } catch (e) {
        return {};
    }
}

const useCreateBusiness = () => {
    const navigate = useNavigate();

    function create(props) {
        return post(userApiRoute('/new-business'), {
            ...getCreateBusinessParams(),
            ...props,
        }).then(data => {
            navigate(`/business/${data.id}`);
        });
    }

    return {
        create,
    };
};

export default useCreateBusiness;
